import styled, { css } from "styled-components/macro";
import { lightFont } from "../../../utils/css/fonts";
import { mobile } from "../../../utils/css/media";

export const StyledLoaderTitle = styled.p`
  margin-top: 25px;
  font-family: ${lightFont};
  font-size: 1.85rem;
  text-align: center;

  ${mobile(css`
    margin-top: 20px;
  `)};
`;
